"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySiteSummary = exports.StudySite = exports.StudySiteAdditionalInfo = exports.StudySiteCrfAdditionalInfo = exports.StudySiteCrf = exports.StudySiteEssential = void 0;
// Note: 수정할 때 lib/rest 쪽 StudySiteEssential 도 함께 수정해야함.
class StudySiteEssential {
}
exports.StudySiteEssential = StudySiteEssential;
// Note: 수정할 때 lib/rest 쪽 StudySiteCrf 도 함께 수정해야함.
class StudySiteCrf {
}
exports.StudySiteCrf = StudySiteCrf;
class StudySiteCrfAdditionalInfo {
}
exports.StudySiteCrfAdditionalInfo = StudySiteCrfAdditionalInfo;
class StudySiteAdditionalInfo {
}
exports.StudySiteAdditionalInfo = StudySiteAdditionalInfo;
// Note: 수정할 때 lib/rest 쪽 StudySite 도 함께 수정해야함.
class StudySite {
}
exports.StudySite = StudySite;
class StudySiteSummary {
}
exports.StudySiteSummary = StudySiteSummary;
//# sourceMappingURL=studySite.js.map